import { z } from "zod";

export const DepositTokenNameEnum = {
  PAXG: "PAXG",
  USDT: "USDT",
  BNB: "BNB",
  ETH: "ETH",
  Profit: "Profit",
  GGOLD: "GGOLD",
} as const;

export const depositTokenNameSchema = z.enum([
  DepositTokenNameEnum.PAXG,
  DepositTokenNameEnum.USDT,
  DepositTokenNameEnum.BNB,
  DepositTokenNameEnum.ETH,
  DepositTokenNameEnum.Profit,
  DepositTokenNameEnum.GGOLD,
]);

export type DepositTokenName = z.infer<
  typeof depositTokenNameSchema
>;